import {
  BottomSheet,
  PageHeaderTopRow,
  PageHeaderWrapper,
  type UseModalState,
} from "@clipboard-health/ui-components";
import { useHistory } from "react-router-dom";

import { ButtonInternalLink } from "../../components/ButtonInternalLink";
import { caseHistoryStatusLabels } from "../constants";
import { IN_HOME_BOOKED_VISIT_HISTORY_FULL_PATH } from "../paths";
import { type CaseHistoryData } from "../types";
import { CaseHistoryDetailsContent } from "./Content";

interface CaseHistoryDetailsBottomSheetProps {
  modalState: UseModalState;
  caseHistoryData: CaseHistoryData;
}

export function CaseHistoryDetailsBottomSheet(props: CaseHistoryDetailsBottomSheetProps) {
  const { modalState, caseHistoryData } = props;
  const history = useHistory();

  return (
    <BottomSheet modalState={modalState} paperSx={{ height: "100%" }}>
      <PageHeaderWrapper variant="tertiary">
        <PageHeaderTopRow
          title={`${caseHistoryStatusLabels[caseHistoryData.attributes.status]} case`}
          LinkComponent={ButtonInternalLink}
          navigateBack={() => {
            history.replace(IN_HOME_BOOKED_VISIT_HISTORY_FULL_PATH);
          }}
        />
      </PageHeaderWrapper>
      <CaseHistoryDetailsContent caseHistoryData={caseHistoryData} />
    </BottomSheet>
  );
}
